<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      :id="`input-billing_address_address_2`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "BillingAddress2",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('billing_address.address_2')],

  data() {
    return {
      name: 'billing_address.address_2',
      defaultLabel: this.$t("Address 2")
    }
  }
}
</script>

<style scoped>

</style>
